var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"body-style":{ padding: '24px 0px' },"bordered":false}},[_c('teacher-profile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }